'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _util = require('../util');

var _constants = require('../constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var initialState = {
  isFetching: false,
  errors: [],
  instances: null
};

var redeemMethods = (0, _util.reducerMethodsFor)('isFetching', _constants.VOUCHER_REDEEM_START, _constants.VOUCHER_REDEEM_FAILURE);

var getMineMethods = (0, _util.reducerMethodsFor)('isFetching', _constants.VOUCHER_GET_MINE_START, _constants.VOUCHER_GET_MINE_FAILURE);

exports.default = (0, _util.createReducer)(initialState, _extends({}, redeemMethods, getMineMethods, (_extends2 = {}, _defineProperty(_extends2, _constants.VOUCHER_REDEEM_SUCCESS, function (state, action) {
  return _extends({}, state, {
    instances: _lodash2.default.filter(state.instances, { id: action.data }),
    isFetching: false
  });
}), _defineProperty(_extends2, _constants.VOUCHER_GET_MINE_SUCCESS, function (state, _ref) {
  var data = _ref.data;

  return _extends({}, state, {
    isFetching: false,
    instances: data && data.vouchers || []
  });
}), _defineProperty(_extends2, _constants.USER_LOGOUT_SUCCESS, function (state, action) {
  return initialState;
}), _defineProperty(_extends2, _constants.SWITCH_BUNDLE_ID, function (state, action) {
  return initialState;
}), _extends2)));


//////////////////
// WEBPACK FOOTER
// ./~/@arreeba/ristoranti-lib/lib/reducer/voucher.js
// module id = 432
// module chunks = 0